import { createSelector } from '@reduxjs/toolkit'
import { RootStoreModel } from '../store.model'

export const routerState = (state: RootStoreModel) => state.router

export const selectCurrentPage = createSelector(
  routerState,
  routerState => routerState.location.pathname
)

export const selectCurrentModule = createSelector(
  routerState,
  routerState => routerState.location.pathname
)

const getPathRoot = (path: string) => {}
